module.exports = __webpack_public_path__ + "static/media/onboard-8-comment.6a341bec.gif";